import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import Video from "video.js";
// import "video.js/dist/video-js.css";

// import 'amfe-flexible';
import "tailwindcss/tailwind.css";
// import './styles/reset.less'
import "./styles/common.less";

// Vue.prototype.$video = Video;
 import VueQuillEditor from 'vue-quill-editor'
 // require styles
 import 'quill/dist/quill.core.css'
 import 'quill/dist/quill.snow.css'
 import 'quill/dist/quill.bubble.css'
 Vue.use(VueQuillEditor)
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
